import React, { FC } from "react";
import { TableBody as MuiTableBody } from "@mui/material";

type Props = React.ComponentProps<typeof MuiTableBody>;

const TableBody: FC<Props> = (props) => {
    return <MuiTableBody {...props}/>
}

export default TableBody;